import { useCallback, useMemo } from 'react';
import ClearFilterButton from 'src/components/design-system/ClearFilterButton';
import useViewDepartment from 'src/hooks/useViewDepartments';
import { initialDepartmentState } from '../ViewDepartmentContext';
const ClearFilters = () => {
  const { setDepartmentsDataState, departmentsDataState } = useViewDepartment();
  const handleClearFilter = useCallback(() => {
    setDepartmentsDataState(initialDepartmentState);
  }, [setDepartmentsDataState]);

  const isClearFiltersDisabled = useMemo(
    () => !departmentsDataState?.filter?.filters?.length,
    [departmentsDataState?.filter]
  );
  return <ClearFilterButton disabled={isClearFiltersDisabled} onClick={handleClearFilter} />;
};

export default ClearFilters;
